<template>
  <BaseMultiToggle
    v-bind="$attrs"
    v-on="$listeners"
    v-model="selectedOptionId"
    :styleConfig="styleConfig"
  >
    <template v-slot:option="{ option }">
      {{ labelKey === null ? option : option[labelKey] }}
    </template>
  </BaseMultiToggle>
</template>

<script>
  import BaseMultiToggle from '@base/v2/base-multi-toggle'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'MultiTogglePrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change',
    },
    components: {
      BaseMultiToggle,
    },
    props: {
      vmodelValue: {
        type: [Number, Object, String],
        required: false,
        default: null,
      },
      labelKey: {
        type: [Object, String],
        required: false,
        default: null,
      },
    },
    data: function () {
      return {
        selectedOptionId: this.vmodelValue,
        styleConfig: {
          button: {
            height: '100%',
          },
          buttonFirst: {
            height: '100%',
          },
          buttonLast: {
            height: '100%',
          },
          container: {
            height: '26px',
          },
        },
      };
    },
    created: function () {
      const buttonCommonStyleConfig = {
        backgroundColor: {
          '': this.color.light1(),
          selected: this.color.select1(),
          'selected-hover': this.color.select1(),
          'selected-disabled': this.color.dark3(),
        },
        color: {
          '': this.color.dark4(),
          disabled: this.color.dark3(),
          selected: this.color.light1(),
          'selected-hover': this.color.light1(),
          'selected-disabled': this.color.light1(),
        },
        cursor: {
          '': 'pointer',
          disabled: 'default',
        },
        border: {
          '': `solid ${this.color.dark4()}`,
          disabled: `solid ${this.color.dark3()}`,
          selected: `solid ${this.color.select1()}`,
          'selected-hover': `solid ${this.color.select1()}`,
          'selected-disabled': `solid ${this.color.dark3()}`,
        },
        fontFamily: FontStyle.family.primary,
        fontSize: FontStyle.size.md,
        fontWeight: FontStyle.weight.lg,
        height: '100%',
        padding: `0 ${Layout.space.md}`,
        userSelect: 'none',
      };

      Object.assign(
        this.styleConfig.button,
        {
          ...buttonCommonStyleConfig,
          borderRadius: 'none',
          borderWidth: {
            '': '1px 1px 1px 0',
            selected: 0,
            'selected-hover': 0,
            'selected-disabled': 0,
          },
        },
      );
      Object.assign(
        this.styleConfig.buttonFirst,
        {
          ...buttonCommonStyleConfig,
          borderRadius: `${Layout.space.xs} 0 0 ${Layout.space.xs}`,
          borderWidth: {
            '': '1px',
            selected: 0,
            'selected-hover': 0,
            'selected-disabled': 0,
          },
        },
      );
      Object.assign(
        this.styleConfig.buttonLast,
        {
          ...buttonCommonStyleConfig,
          borderRadius: `0 ${Layout.space.xs} ${Layout.space.xs} 0`,
          borderWidth: {
            '': '1px 1px 1px 0',
            selected: 0,
            'selected-hover': 0,
            'selected-disabled': 0,
          },
        },
      );
      Object.assign(
        this.styleConfig.container,
        {
          cursor: 'default',
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.selectedOptionId = newVal;
      }
    },
  };
</script>
